import MValidationComponent from "./MValidationComponent.vue";
export default MValidationComponent;
